export default function BrandStory() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/42037423f97f3b0bfde1df7f519aa52f.jpg"
                alt="Natural Water Source"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-teal-50 rounded-3xl -z-10"></div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <p className="text-teal-600 font-medium text-sm tracking-wider uppercase">Our Beginning</p>
              <h2 className="text-5xl font-light text-gray-900 leading-tight">
                좋은 물이란<br />무엇인가?
              </h2>
            </div>

            <div className="space-y-6 text-gray-600 font-light leading-relaxed">
              <p>
                Heritage Water는 하나의 질문에서 시작되었습니다.<br />
                "좋은 물이란 무엇인가?"
              </p>

              <p>
                시장에는 수많은 생수 브랜드가 있지만, 대부분은 정제 기술과 첨가물로 물을 '만들어냅니다'. 우리는 다른 길을 선택했습니다.
              </p>

              <p>
                유네스코 생물권보전지역의 깊은 암반수를 찾아냈고, 그 물이 가진 자연 그대로의 미네랄 밸런스를 발견했습니다. 우리가 할 일은 단 하나였습니다.
              </p>

              <p className="text-xl text-gray-900 font-normal italic">
                "자연이 만든 완벽함을 흐트러뜨리지 않는 것"
              </p>

              <p>
                Heritage Water는 원수의 품질을 최우선으로 삼으며, 불필요한 정제 과정을 거부합니다. 자연이 수천 년에 걸쳐 만들어낸 물, 그것이 우리가 제공하는 가장 순수한 답입니다.
              </p>
            </div>

            <div className="pt-4">
              <div className="inline-flex items-center gap-3 text-teal-600 font-medium cursor-pointer hover:gap-5 transition-all">
                <span>Discover Our Philosophy</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
